import type { Address } from 'viem'
import { erc20Abi } from 'viem'

import { EVERGREEN_FARMING_ABI } from './abis/evergreenFarming'
import { FARMING_ABI } from './abis/farming'
import { I_UNISWAP_V2_PAIR_ABI } from './abis/iUniswapV2Pair'
import { THORCHAIN_ROUTER_ABI } from './abis/thorchainRouter'
import { UNISWAP_V2_ROUTER_02_ABI } from './abis/uniswapV2Router02'
import { ContractType } from './types'

export const WETH_TOKEN_CONTRACT = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'
export const FOX_TOKEN_CONTRACT = '0xc770EEfAd204B5180dF6a14Ee197D99d808ee52d'

// Staking contract addresses as string literals
export const ETH_FOX_STAKING_V1_CONTRACT = '0xdd80e21669a664bce83e3ad9a0d74f8dad5d9e72' as const
export const ETH_FOX_STAKING_V2_CONTRACT = '0xc54b9f82c1c54e9d4d274d633c7523f2299c42a0' as const
export const ETH_FOX_STAKING_V3_CONTRACT = '0x212ebf9fd3c10f371557b08e993eaab385c3932b' as const
export const ETH_FOX_STAKING_V4_CONTRACT = '0x24fd7fb95dc742e23dc3829d3e656feeb5f67fa0' as const
export const ETH_FOX_STAKING_V5_CONTRACT = '0xc14eaa8284feff79edc118e06cadbf3813a7e555' as const
export const ETH_FOX_STAKING_V6_CONTRACT = '0xebb1761ad43034fd7faa64d84e5bbd8cb5c40b68' as const
export const ETH_FOX_STAKING_V7_CONTRACT = '0x5939783dbf3e9f453a69bc9ddc1e492efac1fbcb' as const
export const ETH_FOX_STAKING_V8_CONTRACT = '0x662da6c777a258382f08b979d9489c3fbbbd8ac3' as const
export const ETH_FOX_STAKING_V9_CONTRACT = '0x721720784b76265aa3e34c1c7ba02a6027bcd3e5' as const
export const ETH_FOX_STAKING_EVERGREEN_CONTRACT =
  '0xe7e16e2b05440c2e484c5c41ac3e5a4d15da2744' as const

export const foxEthStakingContractAddresses = [
  ETH_FOX_STAKING_V9_CONTRACT,
  ETH_FOX_STAKING_V8_CONTRACT,
  ETH_FOX_STAKING_V7_CONTRACT,
  ETH_FOX_STAKING_V6_CONTRACT,
  ETH_FOX_STAKING_V5_CONTRACT,
  ETH_FOX_STAKING_V4_CONTRACT,
  ETH_FOX_STAKING_V3_CONTRACT,
  ETH_FOX_STAKING_V2_CONTRACT,
  ETH_FOX_STAKING_V1_CONTRACT,
  ETH_FOX_STAKING_EVERGREEN_CONTRACT,
] as const

// Exported as a string literal for contract address discrimination purposes
export const ETH_FOX_POOL_CONTRACT = '0x470e8de2eBaef52014A47Cb5E6aF86884947F08c' as const

// Uniswap V2
export const UNISWAP_V2_ROUTER_02_CONTRACT_MAINNET =
  '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D' as const
export const UNISWAP_V2_FACTORY_CONTRACT_MAINNET = '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f'

// Uniswap V3
export const UNISWAP_V3_QUOTER_CONTRACT_MAINNET = '0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6'
export const UNISWAP_V3_POOL_FACTORY_CONTRACT_MAINNET = '0x1F98431c8aD98523631AE4a59f267346ea31F984'

// THORChain Contracts
export const THOR_ROUTER_CONTRACT_MAINNET = '0xd37bbe5744d730a1d98d8dc97c42f0ca46ad7146'
export const TS_AGGREGATOR_TOKEN_TRANSFER_PROXY_CONTRACT_MAINNET =
  '0xF892Fef9dA200d9E84c9b0647ecFF0F34633aBe8'

// RFOX on Arbitrum ERC1967Proxy contract address
// Uncomment me if you want to test RFOX with a shorter cooldown period
// export const RFOX_PROXY_CONTRACT: Address = '0x1094c4a99fce60e69ffe75849309408f1262d304'
// export const RFOX_UNI_V2_ETH_FOX_PROXY_CONTRACT: Address = '0x4843373F380aDf80C779cD4dEDC6452E414f7634'

export const RFOX_PROXY_CONTRACT: Address = '0xaC2a4fD70BCD8Bab0662960455c363735f0e2b56'
export const RFOX_UNI_V2_ETH_FOX_PROXY_CONTRACT: Address =
  '0x83B51B7605d2E277E03A7D6451B1efc0e5253A2F'
export const RFOX_REWARD_RATE = 1n * 10n ** 27n
export const RFOX_WAD = 1n * 10n ** 18n

export const CONTRACT_ADDRESS_TO_ABI = {
  [ETH_FOX_POOL_CONTRACT]: I_UNISWAP_V2_PAIR_ABI,
  [ETH_FOX_STAKING_V1_CONTRACT]: FARMING_ABI,
  [ETH_FOX_STAKING_V2_CONTRACT]: FARMING_ABI,
  [ETH_FOX_STAKING_V3_CONTRACT]: FARMING_ABI,
  [ETH_FOX_STAKING_V4_CONTRACT]: FARMING_ABI,
  [ETH_FOX_STAKING_V5_CONTRACT]: FARMING_ABI,
  [ETH_FOX_STAKING_V6_CONTRACT]: FARMING_ABI,
  [ETH_FOX_STAKING_V7_CONTRACT]: FARMING_ABI,
  [ETH_FOX_STAKING_V8_CONTRACT]: FARMING_ABI,
  [ETH_FOX_STAKING_V9_CONTRACT]: FARMING_ABI,
  [ETH_FOX_STAKING_EVERGREEN_CONTRACT]: EVERGREEN_FARMING_ABI,
  [FOX_TOKEN_CONTRACT]: erc20Abi,
  [UNISWAP_V2_ROUTER_02_CONTRACT_MAINNET]: UNISWAP_V2_ROUTER_02_ABI,
  // THOR Router Mainnet
  [THOR_ROUTER_CONTRACT_MAINNET]: THORCHAIN_ROUTER_ABI,
} as const

export const CONTRACT_TYPE_TO_ABI = {
  [ContractType.UniV2Pair]: I_UNISWAP_V2_PAIR_ABI,
  [ContractType.ERC20]: erc20Abi,
  [ContractType.ThorRouter]: THORCHAIN_ROUTER_ABI,
} as const

// 0x proxy contracts - all EVM chains except Optimism have the same address
export const ZRX_ETHEREUM_PROXY_CONTRACT = '0xDef1C0ded9bec7F1a1670819833240f027b25EfF'
export const ZRX_OPTIMISM_PROXY_CONTRACT = '0xDEF1ABE32c034e558Cdd535791643C58a13aCC10'

// Cowswap
export const COWSWAP_SETTLEMENT_CONTRACT_MAINNET = '0x9008D19f58AAbD9eD0D60971565AA8510560ab41'

// Arbitrum Bridge contracts
export const ARB_OUTBOX_CONTRACT = '0x0B9857ae2D4A3DBe74ffE1d7DF045bb7F96E4840'
export const ARB_SYS_CONTRACT = '0x0000000000000000000000000000000000000064'
export const ARBITRUM_L2_ERC20_GATEWAY_PROXY_CONTRACT = '0x09e9222E96E7B4AE2a407B98d48e330053351EEe'
export const ARB_RETRYABLE_TX_CONTRACT = '0x000000000000000000000000000000000000006e'
export const L2_ARBITRUM_CUSTOM_GATEWAY_CONTRACT = '0x096760F208390250649E3e8763348E783AEF5562'
export const L2_ARBITRUM_GATEWAY_CONTRACT = '0x5288c571Fd7aD117beA99bF60FE0846C4E84F933'
export const L1_ARBITRUM_GATEWAY_CONTRACT = '0x72ce9c846789fdb6fc1f34ac4ad25dd9ef7031ef'
export const L1_ORBIT_CUSTOM_GATEWAY_CONTRACT = '0x4Dbd4fc535Ac27206064B68FfCf827b0A60BAB3f'

export const SHAPE_SHIFT_ROUTER_CONTRACT = '0x6a1e73f12018D8e5f966ce794aa2921941feB17E'
export const FOXY_STAKING_CONTRACT = '0xee77aa3Fd23BbeBaf94386dD44b548e9a785ea4b'

// Fox Staking Contracts
export const UNI_V2_FOX_STAKING_REWARDS_V1_CONTRACT = '0xDd80E21669A664Bce83E3AD9a0d74f8Dad5D9E72'
export const UNI_V2_FOX_STAKING_REWARDS_V2_CONTRACT = '0xc54B9F82C1c54E9D4d274d633c7523f2299c42A0'
export const UNI_V2_FOX_STAKING_REWARDS_V3_CONTRACT = '0x212ebf9FD3c10F371557b08E993eAaB385c3932b'
export const UNI_V2_FOX_STAKING_REWARDS_V4_CONTRACT = '0x24FD7FB95dc742e23Dc3829d3e656FEeb5f67fa0'
export const UNI_V2_FOX_STAKING_REWARDS_V5_CONTRACT = '0xC14eaA8284feFF79EDc118E06caDBf3813a7e555'
export const UNI_V2_FOX_STAKING_REWARDS_CONTRACTS = [
  UNI_V2_FOX_STAKING_REWARDS_V1_CONTRACT,
  UNI_V2_FOX_STAKING_REWARDS_V2_CONTRACT,
  UNI_V2_FOX_STAKING_REWARDS_V3_CONTRACT,
  UNI_V2_FOX_STAKING_REWARDS_V4_CONTRACT,
  UNI_V2_FOX_STAKING_REWARDS_V5_CONTRACT,
] as const

// Permit2 is deployed here across all chains.
// https://0x.org/docs/introduction/0x-cheat-sheet#permit2-contract
export const PERMIT2_CONTRACT = '0x000000000022D473030F116dDEE9F6B43aC78BA3'
